import React from "react";
import classNames from "classnames";
import type { HintTextProps } from "./types";
import styles from "./HintText.module.css";

/**
 * HintText Atom
 *
 * Displays instructional or helper text with an optional icon prefix.
 * Use for providing guidance or contextual information to users.
 *
 * @example
 * ```tsx
 * <HintText icon={<Icon name="info" size="sm" />}>
 *   Click on days to select them
 * </HintText>
 * ```
 */
export const HintText: React.FC<HintTextProps> = ({
  children,
  icon,
  variant = "default",
  className,
  "data-testid": testId,
}) => {
  return (
    <div
      className={classNames(styles.hint, styles[variant], className)}
      data-testid={testId}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>{children}</span>
    </div>
  );
};

HintText.displayName = "HintText";

export default HintText;
